export default "__VITE_ASSET__AUJ$Gvzr__"